export const tableOption = {
  border: true,
  index: false,
  stripe: true,
  menuAlign: 'center',
  refreshBtn: false,
  editBtn: false,
  delBtn: false,
  align: 'center',
  addBtn: false,
  viewBtn: false,
  column: [{
    label: '角色名',
    prop: 'roleName',
    span: 24,
    rules: [{
      required: true,
      message: '角色名不能为空',
      trigger: 'blur'
    },
    {
      min: 3,
      max: 20,
      message: '长度在 3 到 20 个字符',
      trigger: 'blur'
    }]
  }, {
    width: 150,
    label: '角色描述',
    prop: 'roleDesc',
    overHidden: true,
    span: 24,
    rules: [{
      required: true,
      message: '角色描述不能为空',
      trigger: 'blur'
    }]
  }, {
    label: '创建时间',
    prop: 'createTime',
    type: 'datetime',
    format: 'yyyy-MM-dd HH:mm',
    valueFormat: 'yyyy-MM-dd HH:mm:ss',
    editVisdiplay: false,
    addVisdiplay: false,
    span: 24
  }]
}
